import { Stack, Tooltip, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Warning";
import WarningIcon from "@mui/icons-material/Report";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import BugReportIcon from "@mui/icons-material/BugReport";
import { groupBy } from "../../scripts/utils";
import { AlertColors, AlertLevelClass } from "./alert_enums";

function AlertIcon({ icon, style }) {
  if (icon === 0) {
    return <InfoIcon htmlColor={AlertColors.INFO} sx={style} />;
  } else if (icon === 1) {
    return <WarningIcon htmlColor={AlertColors.WARNING} sx={style} />;
  } else if (icon === 2) {
    return <ErrorIcon htmlColor={AlertColors.ERROR} sx={style} />;
  } else if (icon === 3) {
    return <SettingsIcon htmlColor={AlertColors.CONFIG} sx={style} />;
  } else if (icon === 4) {
    return <ErrorIcon htmlColor={AlertColors.CRITICAL} sx={style} />;
  } else if (icon === 5) {
    return <HourglassEmptyIcon htmlColor={AlertColors.PENDING} sx={style} />;
  } else if (icon === 6) {
    return <BugReportIcon htmlColor={AlertColors.DEBUG} sx={style} />;
  } else {
    return <CheckIcon htmlColor={AlertColors.SUCCESS} sx={style} />;
  }
}

export default function BoxAlerts({ alerts, sx, hideOK }) {
  function groupedInfo(alerts) {
    return (
      <>
        {alerts.map((alert, idx) => (
          <div key={idx}>
            {alerts.length > 1 && <div>{idx + 1}: </div>}
            {alert.info.split('\n').map((line, lineIdx) => (
              <div key={lineIdx}>{line}</div>
            ))}
          </div>
        ))}
      </>
    );
  }

  function sortIcons(a, b) {
    if (a > AlertLevelClass.ERROR && b <= AlertLevelClass.ERROR) return 1;
    if (b > AlertLevelClass.ERROR && a <= AlertLevelClass.ERROR) return -1;
    else return b - a;
  }

  if (alerts === undefined || alerts.length === 0) {
    return (
      <Stack
        display="flex"
        ml={sx?.marginLeft}
        justifyContent={sx.justifyContent ?? "center"}
        alignItems={sx.alignItems ?? "center"}
        spacing={1}
        direction="row"
      >
        <CheckIcon sx={sx} htmlColor={AlertColors.SUCCESS} />
      </Stack>
    );
  }

  const groupedAlerts = groupBy(alerts, "icon");
  return (
    <Stack
      display="flex"
      ml={sx?.marginLeft}
      justifyContent={sx.justifyContent ?? "center"}
      alignItems={sx.alignItems ?? "center"}
      spacing={1}
      direction="row"
    >
      {Object.keys(groupedAlerts)
        .sort(sortIcons)
        .map((key, idx) => (
          <Tooltip key={idx} title={groupedInfo(groupedAlerts[key])} arrow placement="right">
            <Stack
              display="flex"
              ml={sx?.marginLeft}
              justifyContent={sx.justifyContent ?? "center"}
              alignItems={sx.alignItems ?? "center"}
              direction="row"
            >
              <Typography color="#2F4F4F" variant="body2" mr={groupedAlerts[key].length > 1 ? 0.2 : 0}>
                {groupedAlerts[key].length > 1 ? groupedAlerts[key].length : ""}
              </Typography>
              <AlertIcon icon={parseInt(key)} />{" "}
            </Stack>
          </Tooltip>
        ))}
    </Stack>
  );
}
